import React from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import {
  DelegationCargosPage,
  DelegationScanConsolidatePage,
  DelegationScanReceivePage,
} from '@ontruck/fe-core';
import config from 'config';
import { useSelector } from 'react-redux';
import { DelegationCargoDetailModule } from './delegation-cargo-detail-module';
import '../../modules/emergencies/components/ui/emergencyPopup.css';

export default function DelegationModule({ match }) {
  const token = useSelector((state) => state?.user?.access_token);
  const delegations = useSelector((state) => state?.me?.delegations || []);
  const history = useHistory();

  let delegationConfig = {
    apiBase: `${config.BASE_URL}`,
    token,
    delegations,
  };

  const handleGoToDelegation = () => {
    history.push('/delegation');
  };

  const handleGoToScanReceive = () => {
    history.push(`${match?.url}/scan/receive`);
  };

  const handleGoToScanConsolidate = () => {
    history.push(`${match?.url}/scan/consolidate`);
  };

  const handleGoToCargoDetail = (id) => {
    history.push(`${match?.url}/cargos/${id}`);
  };

  return (
    <Switch>
      <Route
        component={() => {
          return (
            <DelegationCargosPage
              config={delegationConfig}
              onGoToCargoDetail={handleGoToCargoDetail}
              onGoToScanReceive={handleGoToScanReceive}
            />
          );
        }}
        exact
        path={`${match?.url}`}
      />
      <Route exact path={`${match?.url}/cargos/:id`}>
        <DelegationCargoDetailModule config={delegationConfig} />
      </Route>
      <Route
        component={() => {
          return (
            <DelegationScanReceivePage
              config={delegationConfig}
              onGoToCargosList={handleGoToDelegation}
              onGoToScanConsolidate={handleGoToScanConsolidate}
            />
          );
        }}
        exact
        path={`${match?.url}/scan/receive`}
      />
      <Route
        component={() => {
          return (
            <DelegationScanConsolidatePage
              config={delegationConfig}
              onGoToCargosList={handleGoToDelegation}
              onGoToScanReceive={handleGoToScanReceive}
            />
          );
        }}
        exact
        path={`${match?.url}/scan/consolidate`}
      />
    </Switch>
  );
}
